<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeOrders.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/sales/representative-orders/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeOrder"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-order="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativeOrders.per_page"
        layout="total, prev, pager, next"
        :total="representativeOrders.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    representativeOrders() {
      return this.$store.getters['representativeOrder/representativeOrders'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['representativeOrder/tableConfig']));
    },
    loading() {
      return this.$store.getters['representativeOrder/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('representativeOrder/setFilterString', '');
    this.$store.commit('representativeOrder/setCurrentPage', this.currentPage);
    this.$store.commit('representativeOrder/setSorting', this.currentSort);
    await this.$store.dispatch('representativeOrder/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('representativeOrder/setCurrentPage', val);
      this.$store.dispatch('representativeOrder/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('representativeOrder/setSorting', { prop, order, compareType: compareTypes[prop] || 'string' });
        this.$store.dispatch('representativeOrder/fetchAll');
      }
    },
  },
};
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
